import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'
import { ModalContentWrapper } from '@ui/v2/Modal/ModalContentWrapper'

import styles from './NoGroupModal.module.scss'

interface NoGroupModalProps {
  closeModal: () => void
  onCreate: () => void
}

export const NoGroupModal: FC<NoGroupModalProps> = (props) => {
  const { closeModal, onCreate } = props

  const { t } = useTranslation()

  return (
    <ModalContentWrapper
      title={t('IB.RebatesPage.ClientsPage.Adding to group')}
      applyLabel={t('Create')}
      onClose={closeModal}
      onConfirm={onCreate}
      onCancel={closeModal}
      isCancelShownOnDesktop
    >
      <Body1 className={styles.noGroupModal}>
        {t('IB.RebatesPage.ClientsPage.Create your first group and automate your work!')}
      </Body1>
    </ModalContentWrapper>
  )
}
